var React = require('react');
var PropTypes = React.PropTypes;
var ReviewTaskRes = require('../../../resources/review_task');
var Auth = require('../../../resources/auth');
var Helpers = require("../../../utils/helpers");
var ConceptRes = require('../../../resources/concept');
// import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
var moment = require('moment');
import { Link, browserHistory } from 'react-router';
var $ = require('jquery');
import { Pager } from 'react-bootstrap';
import ConfirmModal from '../../Modal/Confirm';

var TEACHER_MODE = [{
  title: "On Going",
  value: ["new", "reviewing"],
  actions: ["review"],
  notes: [
    'Includes your new assigned and in-review collection-tasks'
  ]
}, {
  title: "Completed",
  value: ["done", "cancelled"],
  actions: [],
  notes: [
    'Includes your reviewed-by-admin & canceled-by-admin & in-review collection-tasks which you (reviewer) click on "Finish" in review page or closed by admin'
  ]
}];

var ADMIN_MODE =[{
  title: "On Going",
  value: ["new", "reviewing"],
  actions: ["cancel"],
  notes: [
    'Includes all new assigned and in-review collection-tasks that have been assigned to reviewers (but not completed yet)'
  ]
}, {
  title: "Completed",
  value: ["done", "cancelled"],
  actions: [],
  notes: [
    'Includes your reviewed-by-admin & canceled-by-admin & in-review collection-tasks which reviewers clicks on "Finish" in review page or closed by you (admin) when click on "Approve" or "Reject" or "Send back to setter for revision"'
  ]
}]

var ITEM_LIMIT = 20;

var TasksManagement = React.createClass({
  retrieveTaskCollections: function(mode, callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    mode = mode || this.state.currentMode;
    var query = {};
    query.skip = ITEM_LIMIT * (currentPager - 1);
    query.limit = ITEM_LIMIT;
    query.sort = this.state.sort || "-dateCreated";
    query.include = "content";
    var conditions = {
      status: {
        "$in": mode.value
      },
      type: "COLLECTION_REVIEW"
    }
    var currentUser = Auth.getCurrentUser();
    var isAdmin = currentUser.status.indexOf('admin')>=0;
    if (!isAdmin) {
      conditions.reviewer = Auth.getCurrentUser()._id;
    }
    query.conditions = JSON.stringify(conditions);
    var options = {query: query};
    ReviewTaskRes.retrieveReviewTaskList(options, function(err, res) {
      console.log(err, res);
      if (!err && res) {
        _this.setState({
          isLoading: false,
          reviewTaskData: res
        })
      } else {
        _this.setState({
          isLoading: false,
          reviewTaskData: [{}]
        })
      }
      return callback(err, res);
    })
  },

  retrieveConceptsMap: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      _this.setState({
        conceptsMap: conceptsMap
      })
      return callback(err, conceptsMap);
    })
  },

  changeStatusMode: function(mode) {
    this.setState({
      currentMode: mode,
      reviewTaskData: [],
      isLoading: true
    }, function() {
      this.retrieveTaskCollections(mode);
    });
  },

  cancelTask: function(task) {
    var options = {
      taskId: task._id,
      body: {
        status: 'cancelled'
      }
    }
    var _this = this;
    $("body").addClass("heavy-load");
    ReviewTaskRes.updateReviewTask(options, function(err, res) {
      $("body").removeClass("heavy-load");
      if (err) return;
      var tasks = _this.state.reviewTaskData;
      tasks.splice(tasks.indexOf(task), 1);
      _this.setState({reviewTaskData: tasks});
    })
  },

  actionByType: function(type, data) {
    var result;
    type = type.toLowerCase();
    switch(type) {
      case "review":
        if (data.status === 'new')
          result = <Link to={"/review/" + data._id}><button className="btn primary"><i className="fa fa-play"></i>Start</button></Link>
        else if (data.status === 'reviewing')
          result = <Link to={"/review/" + data._id}><button className="btn secondary"><i className="fa fa-arrow-right"></i>Continue</button></Link>
        break;
      case "cancel":
        result = <button className="btn secondary" onClick={this.cancelTask.bind(this, data)}><i className="fa fa-times"></i>Cancel</button>
      default: break;
    }
    return result;
  },

  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
        _this = this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveTaskCollections(null, function(err, res) {
      })
    })
  },

  getInitialState: function() {
    return {
      statusMode: [],
      currentMode: {},
      reviewTaskData: [],
      currentPager: 1,
      sort: "-dateCreated"
    };
  },

  changeSort: function(chosenSort) {
    var newSort;
    if (this.state.sort.indexOf(chosenSort) >= 0) {
      var sort = this.state.sort;
      if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
      else newSort = '-'  + sort;
    } else {
      newSort = '-' + chosenSort;
    }
    this.setState({
      sort: newSort,
      reviewTaskData: [],
      isLoading: true,
      currentPager: 1
    }, () => {
      this.retrieveTaskCollections();
    })
  },

  render: function() {
    var _this = this,
        ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
        descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
        sortIcon = <span className="fa fa-sort padding-left-5"></span>,
        sort = this.state.sort;
    function getSortIcon(currentSort) {
      if (sort.indexOf(currentSort) >= 0) {
        if (sort.charAt(0) === '-') return descSortIcon;
        else return ascSortIcon;
      } else {
        return sortIcon;
      }
    }
    return (
      <div className="collections">
        <div className="content-toolbar">
          <h3>Task Management</h3>
        </div>
        <div style={{"border": "1px solid #ddd", "padding": "10px"}}>
          <div className="collection-statuses">
            <div className="dp-table" style={{"tableLayout": "fixed", "width": "100%"}}>
              {
                this.state.statusMode.map(function(mode, index) {
                  return (
                    <div key={index} className={"dp-table-cell cell " + (_this.state.currentMode === mode ? 'active' : '')} onClick={_this.changeStatusMode.bind(_this, mode)}>{mode.title}</div>
                  )
                })
              }
            </div>
          </div>
          {
            this.state.currentMode.notes && 
            <p className="txt-primary text-left" style={{fontSize: "13px"}}>
              {
                _this.state.currentMode.notes.map(function(data, index) {
                  return (<span><i>* {data}</i><br/></span>)
                })
              }
            </p>
          }
          <hr/>
          {
            (_this.state.reviewTaskData.length > 0 && !_this.state.isLoading) &&
            <table className="table table-bordered table-stripe collection-table">
              <thead>
                <tr>
                  <th className="sortable" onClick={this.changeSort.bind(this, '$contentInfo.title')}>
                    Title
                    {getSortIcon('$contentInfo.title')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, '$contentInfo.metadata.subjectName')}>
                    Subject
                    {getSortIcon('$contentInfo.metadata.subjectName')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, '$contentInfo.metadata.conceptName')}>
                    Concept
                    {getSortIcon('$contentInfo.metadata.conceptName')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, 'reviewRound')}>
                    Round
                    {getSortIcon('reviewRound')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, 'reviewerName')}>
                    Reviewers
                    {getSortIcon('reviewerName')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
                    Date Created
                    {getSortIcon('dateCreated')}
                  </th>
                  <th className="sortable" onClick={this.changeSort.bind(this, 'status')}>
                    Status
                    {getSortIcon('status')}
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {
                  _this.state.reviewTaskData.map(function(data, index) {
                    return (
                      <tr key={index}>
                        <td>{data.contentInfo.title || 'No title'}</td>
                        <td>
                          {data.contentInfo.concepts[0] && _this.state.conceptsMap ? Helpers.getSubject(_this.state.conceptsMap, data.contentInfo.concepts[0]).title : "No Subject"}
                        </td>
                        <td>
                          {data.contentInfo.concepts[0] && _this.state.conceptsMap && _this.state.conceptsMap[data.contentInfo.concepts[0]] ? _this.state.conceptsMap[data.contentInfo.concepts[0]].title : "No Concept"}
                        </td>
                        <td>{data.reviewRound}</td>
                        <td>{data.reviewerName}</td>
                        <td>{moment(data.dateCreated).format("MM/DD/YYYY hh:mm A")}</td>
                        <td>{data.status}</td>
                        <td className="action">
                        {
                          _this.state.currentMode.actions.map(function(action, index) {
                            return (
                              <div key={index} className="dp-inline-block">
                                {_this.actionByType(action, data)}
                              </div>
                            )
                          })
                        }
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          }
          {
            _this.state.isLoading &&
            <CircularProgress />
          }
          <Pager>
            {
              _this.state.currentPager > 1 &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, -1)}
                disabled={_this.state.currentPager === 1}
              >
                Previous
              </Pager.Item>
            }
            {' '}
            {
              _this.state.reviewTaskData.length >= ITEM_LIMIT &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, 1)}
                disabled={_this.state.reviewTaskData.length < ITEM_LIMIT}
              >
                Next
              </Pager.Item>
            }
          </Pager>
        </div>
      </div>
    );
  },

  componentDidMount: function() {
    var _this = this;
    var statusMode = this.state.statusMode;
    var currentUser = Auth.getCurrentUser(),
        isAdmin = currentUser.status.indexOf('admin') >= 0;
    if (currentUser.status.indexOf('teacher') >= 0) return browserHistory.push('/collections');
    if (isAdmin) {
      statusMode = ADMIN_MODE;
    } else {
      statusMode = TEACHER_MODE;
    }
    _this.setState({
      isLoading: true,
      statusMode: statusMode,
      currentMode: statusMode[0]
    }, function() {
      this.retrieveTaskCollections(this.state.currentMode);
      this.retrieveConceptsMap();
    });
  }

});

module.exports = TasksManagement;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/TasksManagement/TasksManagement.js
 **/